const MAX_WIDTH: number = 1200;
const MAX_HEIGHT: number = 1200;
const DEFAULT_MIME: string = "image/jpeg";

export function readUploadedFileAsBase64(file: File): Promise<string> {
	const temporaryFileReader = new FileReader();
	return new Promise((resolve, reject) => {
		temporaryFileReader.onerror = () => {
			temporaryFileReader.abort();
			reject(new DOMException("Problem parsing input file."));
		};

		temporaryFileReader.onload = () => {
			resolve(temporaryFileReader.result as string);
		};
		temporaryFileReader.readAsDataURL(file);
	});
}

async function getImageDimensions(base64: string): Promise<{ w: number; h: number }> {
	return new Promise((resolved, _) => {
		const image = new Image();
		image.onload = () => {
			resolved({ w: image.width, h: image.height });
		};
		image.src = base64;
	});
}

export async function resizeImage(file: File): Promise<string> {
	const image = new Image();
	image.src = await readUploadedFileAsBase64(file);
	const dimension = await getImageDimensions(image.src);
	const ratio = dimension.h / dimension.w;
	let width = MAX_WIDTH;
	let height = MAX_HEIGHT;

	if (ratio > 1) {
		// 縦長の画像
		width = height / ratio;
	} else {
		// 横長の画像
		height = width * ratio;
	}

	const canvas = document.createElement("canvas");
	const ctx = canvas.getContext("2d");
	canvas.width = width;
	canvas.height = height;
	ctx!.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
	return canvas.toDataURL(file.type || DEFAULT_MIME);
}

export function base64ToFile(base64: string, name: string, mime?: string): File {
	const bin = atob(base64.replace(/^.*,/, ""));
	// バイナリデータ化
	const buffer = new Uint8Array(bin.length);
	for (let i = 0; i < bin.length; i++) {
		buffer[i] = bin.charCodeAt(i);
	}
	// ファイルオブジェクト生成(この例ではjpegファイル)
	return new File([buffer.buffer], name, { type: mime || DEFAULT_MIME });
}
